import { QuoteMarkers } from "@atoms/QuoteMarkers";
import { CertificateCard } from "@organisms/CertificateCard";
import { quotesPosition } from "@/shared/quotesMarkers";
import { allCertificates } from "./variables";

export const CertificateGrid = () => {
  const CertificateGridElement = document.createElement("div");
  CertificateGridElement.className =
    "app-container grid md:grid-cols-2 border border-gray-100 divide-x divide-y divide-gray-100 lg:grid-cols-3";

  quotesPosition.forEach((position) => {
    CertificateGridElement.appendChild(QuoteMarkers(position));
  });

  allCertificates.forEach((certificate) => {
    CertificateGridElement.appendChild(CertificateCard(certificate));
  });

  return CertificateGridElement;
};
